/*
 *
 * MarketPage actions
 *
 */

import { action, createAsyncAction } from 'typesafe-actions';

import { ActionTypes } from './constants';

export const defaultAction = () => action(ActionTypes.DEFAULT_ACTION);

export const applySearch = (data: any) => action(ActionTypes.APPLY_SEARCH, data);

export const description = createAsyncAction(
  ActionTypes.FETCH_DESCRIPTION_REQUEST,
  ActionTypes.FETCH_DESCRIPTION_SUCCESS,
  ActionTypes.FETCH_DESCRIPTION_FAILURE,
)<void, string, Error>();

export const products = createAsyncAction(
  ActionTypes.FETCH_PRODUCTS_REQUEST,
  ActionTypes.FETCH_PRODUCTS_SUCCESS,
  ActionTypes.FETCH_PRODUCTS_FAILURE,
)<void, {}, Error>();

export const sendRequestNewProductAction = (data: any) => action(ActionTypes.SEND_REQUEST_NEW_PRODUCT, data);

export const setKamereoProducts = (data: any) => action(ActionTypes.SET_KAMEREO_PRODUCTS, data);

export const setSuggestedProducts = (data: any) => action(ActionTypes.SET_SUGGESTED_PRODUCTS, data);


export const setAggregationsData = (data: any) => action(ActionTypes.SET_AGGREGATION_DATA, data);

export const setNewestAggregationsData = (data: any) => action(ActionTypes.SET_NEWEST_AGGREGATION_DATA, data);

export const searchByFilter = (data: any) => action(ActionTypes.SEARCH_BY_FILTER, data);
